import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template6';

type TProps = {
  dashboard: TRecommendation['fixed_card'];
  handleOpenModal: () => void;
};

export const Dashboard = ({
  dashboard: { icon, title, description, cta },
  handleOpenModal,
}: TProps) => {
  const handleButtonClick: React.MouseEventHandler<HTMLAnchorElement> =
    async e => {
      e.preventDefault();
      handleOpenModal();
    };

  return (
    <a
      className="vitrine-template6__card vitrine-template6__card--fixed"
      data-testid="dashboard"
      href={cta.link}
      onClick={handleButtonClick}
    >
      {icon && (
        <span className="vitrine-template6__card--icon">
          <img src={icon} alt={title} />
        </span>
      )}
      <span
        className="vitrine-template6__card--title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <span
        className="vitrine-template6__card--description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <span
        className="vitrine-template6__card--fixed--button"
        data-testid="button"
      >
        <span className="vitrine-template6__card--fixed--button--text">
          {cta.label}
        </span>
        <span className="vitrine-template6__card--fixed--button--icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8.99953 6.71271C8.60953 7.10271 8.60953 7.73271 8.99953 8.12271L12.8795 12.0027L8.99953 15.8827C8.60953 16.2727 8.60953 16.9027 8.99953 17.2927C9.38953 17.6827 10.0195 17.6827 10.4095 17.2927L14.9995 12.7027C15.3895 12.3127 15.3895 11.6827 14.9995 11.2927L10.4095 6.70271C10.0295 6.32271 9.38953 6.32271 8.99953 6.71271Z" />
          </svg>
        </span>
      </span>
    </a>
  );
};
